<template>
    <nav class="mobile-navigation">
        <template v-for="region in regions">
            <a @click.prevent="toggle(region)" href="#" class="mobile-navigation__item mobile-navigation__item--region" :class="{ 'mobile-navigation__item--open' : region.open }">
                <span v-html="region.name"></span>
                <span v-cloak v-if="region.open" class="icon icon--minus"></span>
                <span v-else class="icon icon--plus"></span>
            </a>
            <template v-cloak v-if="region.open" v-for="country in region.countries">
                <div @click.prevent="toggle(country)" class="mobile-navigation__item mobile-navigation__item--country">
                    <span class="flag" :class="`flag--${country.slug}`"></span>
                    <a v-if="country.slug !== 'ae'" @click.stop :href="`${networkUrl}${country.slug}/`">{{ country.name }}</a>
                    <span v-else>{{ country.name }}</span>
                    <span v-cloak v-if="country.open" class="icon icon--minus-gray"></span>
                    <span v-else class="icon icon--plus-gray"></span>
                </div>
                <template v-cloak v-if="country.open">
                    <a v-for="location in country.locations" :href="location.url  + `/`" class="mobile-navigation__item mobile-navigation__item--location" v-html="location.title"></a>
                </template>
            </template>
        </template>
    </nav>
</template>

<script>
    export default {
        props: {
            syncRegions: {
                required: true
            },
            networkUrl: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                regions: null
            }
        },

        created() {            
            this.regions = this.syncRegions;
            if( typeof( this.regions ) === 'object'  ){
                this.regions = Object.keys(this.regions).map(i => this.regions[i])
            }
            this.regions.map((region) => {
                this.$set(region, 'open', false);
                if( typeof( region.countries ) === 'object'  ){
                    region.countries = Object.keys(region.countries).map(i => region.countries[i])
                }
                region.countries.map((country) => {
                    this.$set(country, 'open', false);
                })
            })
        },

        methods: {
            toggle(item) {
                item.open = !item.open;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/LocationAccordion.vue